import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetQualitativeQuestionDomain = (state) =>
  state.get("widgetQualitativeQuestionV2", initialState)

export const makeSelectIsLoadingQuestions = () =>
  createSelector(selectWidgetQualitativeQuestionDomain, (state) =>
    state.get("isLoadingQuestions")
  )

export const makeSelectQuestions = () =>
  createSelector(selectWidgetQualitativeQuestionDomain, (state) =>
    state.get("questions")
  )

export const makeSelectOnlyQuestions = () =>
  createSelector(selectWidgetQualitativeQuestionDomain, (state) =>
    state.get("onlyQuestions")
  )

const makeSelectWidgetQualitativeQuestion = () =>
  createSelector(selectWidgetQualitativeQuestionDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetQualitativeQuestion
export { selectWidgetQualitativeQuestionDomain }
